import { render, staticRenderFns } from "./CheckboxDarkMode.vue?vue&type=template&id=67ca3998&"
import script from "./CheckboxDarkMode.vue?vue&type=script&lang=js&"
export * from "./CheckboxDarkMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports